import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import routes from '@Constants/Routes'
import { trackEvent } from '@Utilities/marketingTags'
import { AmberPill, MOBILE } from '../CustomLanding.styled'
import HeroBg from '../Assets/hero-bg.jpg'
import { colors, finalCta } from '../content'

const FinalCta: React.FC = () => {
	const navigate = useNavigate()

	const handleSignup = () => {
		trackEvent('CTAClick', { cta_text: 'signup', cta_location: 'final_cta' })
		navigate(routes.signup)
	}

	return (
		<Section>
			<BgImage />
			<BgOverlay />
			<Content>
				<Title>
					{finalCta.title}
					<span>{finalCta.titleEmoji}</span>
				</Title>
				<P>
					{finalCta.pBefore}
					<strong>{finalCta.pStrong}</strong>
					{finalCta.pAfter}
				</P>
				<PMuted>{finalCta.p2}</PMuted>
				<PAmber>{finalCta.p3}</PAmber>
				<Actions>
					<AmberPill onClick={handleSignup}>{finalCta.cta}</AmberPill>
				</Actions>
			</Content>
		</Section>
	)
}

export default FinalCta

const Section = styled.section`
	position: relative;
	background: ${colors.navy};
	color: ${colors.paper};
	overflow: hidden;
`

const BgImage = styled.div`
	position: absolute;
	inset: 0;
	background-image: url(${HeroBg});
	background-size: cover;
	background-position: bottom center;
	opacity: 0.9;
`

const BgOverlay = styled.div`
	position: absolute;
	inset: 0;
	background: linear-gradient(to top, rgba(11, 28, 70, 0.9), rgba(11, 28, 70, 0.62));
	${MOBILE} {
		background: linear-gradient(to top, rgba(11, 28, 70, 0.92), rgba(11, 28, 70, 0.62));
	}
`

const Content = styled.div`
	position: relative;
	max-width: 860px;
	margin: 0 auto;
	padding: 36px 32px 40px;
	text-align: center;
	${MOBILE} {
		padding: 32px 18px 36px;
	}
`

const Title = styled.h2`
	font-weight: 800;
	font-size: clamp(22px, 2vw, 30px);
	line-height: 1.3;
	color: #ffffff;
	margin: 0 0 12px;
	text-wrap: balance;
	${MOBILE} {
		font-size: 26px;
		line-height: 1.35;
		margin-bottom: 12px;
	}
`

const P = styled.p`
	margin: 0 0 6px;
	font-size: 16px;
	line-height: 1.8;
	color: rgba(245, 245, 245, 0.82);
	strong {
		color: #ffffff;
		font-weight: 600;
	}
	${MOBILE} {
		font-size: 15px;
		line-height: 1.8;
		margin-bottom: 6px;
	}
`

const PMuted = styled.p`
	margin: 0 0 6px;
	font-size: 15px;
	line-height: 1.8;
	color: rgba(245, 245, 245, 0.62);
	${MOBILE} {
		font-size: 14px;
		line-height: 1.8;
		margin-bottom: 6px;
	}
`

const PAmber = styled.p`
	margin: 0 0 20px;
	font-weight: 700;
	font-size: clamp(17px, 1.5vw, 22px);
	color: ${colors.amber};
	${MOBILE} {
		font-size: 19px;
		margin-bottom: 18px;
	}
`

const Actions = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 14px;
	justify-content: center;
	${MOBILE} {
		flex-direction: column;
		gap: 10px;
	}
`
